/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable-next-line array-callback-return */
import { useState } from 'react';
import { useEffect } from 'react';
import MasterFormGrid from './Grid';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import ContentWrapper from '../../../Layouts/AdminLTE/ContentWrapper';
import { LoadResourceAction } from '../../../Redux/Actions/CrudActions';

export default function MasterFormIndex() {

    const ACTION_TYPE = "COMMON";

    const BACKEND_ROUTE = 'master-forms';

    const PAGE_NAME = 'Master Forms List';

    const [tablecolumn, setTablecolumn] = useState({
        columns: [
            { title: 'Id', field: 'id' },
            { title: 'Form Name', field: 'name' },
            {
                title: 'Form Status', render: rowData => <div> {
                    rowData.status === 1 ?
                        <span className="badge badge-pill badge-success">Active</span>
                        : <span className="badge badge-pill badge-danger">Inactive</span>
                }
                </div>
            },
            { title: 'Utility', field: 'utility_service.utility.name' },
            { title: 'Utility Service', field: 'utility.utility_service' },
            { title: 'Created At', field: 'created_at' },
            { title: 'Updated At', field: 'updated_at' },
        ]
    });

    const dispatch = useDispatch();

    const [data, setData] = useState([]);

    const state = useSelector(state => state.common);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        dispatch(LoadResourceAction(BACKEND_ROUTE, ACTION_TYPE, signal));
        return () => {
            controller.abort();
            console.log("Aborted Customer");
        }
    }, []);

    useEffect(() => {
        if (state.all.success && state.all.list) {
            setData(state.all.list);
            dispatch({ type: `RESTART_${ACTION_TYPE}_LIST` });
        }
    }, [state]);

    return (
        <ContentWrapper page_name={PAGE_NAME} breadcrumbs={breadcrumbs(PAGE_NAME)}>
            <div className="card rounded">
                <div className="card-body p-0">
                    <MasterFormGrid
                        dataList={data}
                        Title={PAGE_NAME}
                        setDataList={setData}
                        columns={tablecolumn}
                    />
                </div>
            </div>
        </ContentWrapper>
    );
};

function breadcrumbs(PageName, IndexRoute = false, IndexPageName = false) {
    return (
        <>
            {IndexPageName && <li className="breadcrumb-item"><NavLink to={IndexRoute}>{IndexPageName}</NavLink></li>}
            <li className="breadcrumb-item active">{PageName}</li>
        </>
    )
}
